import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Check } from 'lucide-react'
import { Checkbox } from '../../ui/checkbox'
import { Input } from '../../ui/input'

function SkillLevelMultiSelect({ skillLevels, value, onChange }) {
  const [search, setSearch] = useState('')

  const safeSkillLevels = skillLevels || []
  const safeValue = value || []

  const selectedSkillLevels = safeSkillLevels.filter((sl) => safeValue.some((v) => v.id === sl.id))
  const filteredSkillLevels = safeSkillLevels.filter((sl) => sl.label?.toLowerCase().includes(search.toLowerCase()))

  function handleToggle(skillLevel) {
    const isSelected = safeValue.some((v) => v.id === skillLevel.id)
    if (isSelected) {
      onChange(safeValue.filter((sl) => sl.id !== skillLevel.id))
    } else {
      const cleanSkillLevel = {
        id: skillLevel.id,
        name: skillLevel.name,
        label: skillLevel.label,
        value: skillLevel.value
      }
      onChange([...safeValue, cleanSkillLevel])
    }
  }

  return (
    <div className="space-y-3">
      <Input
        placeholder="Search skill levels..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="h-9"
      />

      {selectedSkillLevels.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap p-2 bg-gray-50 rounded-md">
          {selectedSkillLevels.map((sl) => (
            <div key={sl.id} className="flex items-center gap-1 bg-white rounded px-2 py-1 border border-gray-200">
              <span className="text-xs text-gray-900">{sl.label}</span>
            </div>
          ))}
        </div>
      )}

      <div className="max-h-[300px] overflow-y-auto border border-gray-200 rounded-md">
        {filteredSkillLevels.length === 0 ? (
          <div className="text-center py-4 text-gray-500 text-sm">No skill levels found</div>
        ) : (
          <div className="divide-y divide-gray-200">
            {filteredSkillLevels.map((skillLevel) => {
              const isSelected = safeValue.some((v) => v.id === skillLevel.id)
              return (
                <div
                  key={skillLevel.id}
                  className="flex items-center space-x-2 p-3 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleToggle(skillLevel)}
                >
                  <Checkbox checked={isSelected} />
                  <span className="flex-1 text-sm text-gray-900">{skillLevel.label}</span>
                  {isSelected && <Check className="h-4 w-4 text-green-600" />}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

SkillLevelMultiSelect.propTypes = {
  skillLevels: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default SkillLevelMultiSelect
